import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type TextToSpeechWidgetStore } from 'widgets/TextToSpeech'
import styles from './styles.module.scss'

export const TextToSpeechModalActions = observer(
  ({ store, onClose }: { store: TextToSpeechWidgetStore; onClose: () => void }) => {
    return (
      <>
        <Button
          className={styles.button}
          text={'Cancel'}
          contained={'secondary'}
          size={'medium'}
          onClick={onClose}
        />
        <Button
          className={styles.button}
          text={'Next'}
          contained={'primary'}
          size={'medium'}
          disabled={store.isEmpty || store.isDisabledCreate}
          onClick={() => {
            onClose()
            store.onCreate()
          }}
        />
      </>
    )
  }
)
